import { toast } from 'react-semantic-toasts';

export const notifySuccess = (singular, verb) => {
    toast({
        type: 'success',
        title: 'Success',
        description: `${singular} ${verb}`,
        animation: 'fade down',
        time: 4000,
    });
};

export const getErrorMessage = (err, singular) => {
    const status = err?.response?.status;
    const serverErrors = err?.response?.data?.errors;
    const serverMessage = Array.isArray(serverErrors) ? serverErrors[0] : null;
    const lower = singular.toLowerCase();

    if (status === 422) {
        return `A ${lower} with that name already exists.`;
    }
    if (status === 400) {
        return serverMessage || `That ${lower} name is invalid.`;
    }
    if (status === 409) {
        return serverMessage || `This ${lower} is in use and cannot be deleted.`;
    }
    if (status === 404) {
        return `That ${lower} no longer exists.`;
    }
    return 'Something went wrong. Please try again.';
};

export const notifyError = (err, singular) => {
    const status = err?.response?.status;

    toast({
        type: 'error',
        title: 'Error',
        description: getErrorMessage(err, singular),
        animation: 'fade down',
        time: status === 409 ? 0 : 8000,
    });
};
